// extracted by mini-css-extract-plugin
export var containerStyle = "hero-module--containerStyle--ba73f";
export var descriptionStyle = "hero-module--descriptionStyle--01567";
export var headingStyle = "hero-module--headingStyle--ac820";
export var heroButtonStyle = "hero-module--heroButtonStyle--a17f1";
export var heroImageStyle = "hero-module--heroImageStyle--e178e";
export var heroImageStyle2 = "hero-module--heroImageStyle2--903cf";
export var heroImageWrapperStyle = "hero-module--heroImageWrapperStyle--ae412";
export var heroImageWrapperStyle2 = "hero-module--heroImageWrapperStyle2--e9735";
export var leftWrapper = "hero-module--leftWrapper--55855";